import { functions } from "../firebase";

export type SocialProfile = {
  id: string;
  platform: string;
  name?: string;
  username?: string;
  picture?: string;
};

export type SocialConfig = {
  provider: string;
  hasGroup: boolean;
  connected: boolean;
  profiles: SocialProfile[];
};

export type ScheduleSocialResult = {
  ok: boolean;
  postId?: string;
  error?: string;
};

// Read the community's connection state (which accounts are linked).
export const getSocialConfig = async (
  communityId: string
): Promise<SocialConfig> => {
  const callable = functions.httpsCallable("getSocialConfig");
  const res = await callable({ communityId });
  return res.data as SocialConfig;
};

// Get the white-label connection URL to open so a coach links an account.
export const startSocialConnect = async (params: {
  communityId: string;
  platform?: string;
  redirectUrl: string;
}): Promise<{ url: string; profileGroupId: string }> => {
  const callable = functions.httpsCallable("startSocialConnect");
  const res = await callable(params);
  return res.data as { url: string; profileGroupId: string };
};

// Refresh connected accounts after the coach returns from the connect flow.
export const listSocialProfiles = async (
  communityId: string
): Promise<SocialProfile[]> => {
  const callable = functions.httpsCallable("listSocialProfiles");
  const res = await callable({ communityId });
  return (res.data as { profiles: SocialProfile[] })?.profiles ?? [];
};

// Schedule a post to the community's connected accounts. Media URLs come
// pre-resolved from the Media Studio (carousel images or a rendered reel).
export const scheduleSocialPost = async (payload: {
  communityId: string;
  projectId?: string;
  platforms?: string[];
  caption: string;
  mediaUrls: string[];
  mediaType: "image" | "video";
  scheduledAt: string;
}): Promise<ScheduleSocialResult> => {
  const callable = functions.httpsCallable("scheduleSocialPost", {
    timeout: 120000,
  });
  const res = await callable(payload);
  return res.data as ScheduleSocialResult;
};
